module.exports = __WEBPACK_EXTERNAL_MODULE_178__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/core-client/js/core-client/i18n/Formatter"
// module id = 178
// module chunks = 0